module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('dashboard') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('worldmap') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/worldmap"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Worldmap")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('testimonies') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/testimonies"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Testimonies")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('cases') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/cases"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cases")])])]), _vm._v(" "), (_vm.role === 'WWOW_ADMIN') ? _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('users') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/users"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Users")])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    class: [_vm.$route.fullPath.indexOf('subscriptions') > -1 ? 'active' : ''],
    attrs: {
      "tag": "li",
      "to": "/subscriptions"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Subscriptions")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94e8b688"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 451
// module chunks = 1